export function phoneValidate($field) {
    let status = false;
    $.ajax({
        url: window.ajax_url,
        data: {
            'action': 'phone_validate',
            'phone': $field.val(),
            'code': 'GB'
        },
        type: 'POST',
        async: false,
    }).done(function (res) {
        let response = JSON.parse(res).response;
        console.log(response);
        if(response !== null) {
            if(response.Status.Success === true && response.Result !== null) {
                if (response.Result.ValidationResult === 'Invalid' || response.Result.ValidationResult === 'Unavailable') {
                    $field.addClass('is-invalid');
                    status = false;
                } else {
                    $field.removeClass('is-invalid');
                    status = true;
                }
            } else {
                console.log(response.Status.ErrorMessage + ' ' + `CreditsRemaining: ${response.Status.CreditsRemaining}`);
            }
        } else {
            status = true;
        }
    }).fail(function (error) {
        console.log(error);
    });
    return status;
}


// WEBPACK FOOTER //
// ./scripts/util/phoneValidate.js